import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore, doc, onSnapshot } from "firebase/firestore";

let app;
let analytics;
let db;

export function _init(target) {
    if (app != undefined) {
        return;
    }

    const config =
        target == "release"
            ? {
                  apiKey: "AIzaSyB1aDTWI5nez8SJe6oGp-o2LErxAEDSktQ",
                  authDomain: "ji-cloud.firebaseapp.com",
                  databaseURL: "https://ji-cloud.firebaseio.com",
                  projectId: "ji-cloud",
                  storageBucket: "ji-cloud.appspot.com",
                  messagingSenderId: "516631917755",
                  appId: "1:516631917755:web:842b4c92c60041dd5ca59e",
                  measurementId: "G-4V46KRQZPB",
              }
            : {
                  apiKey: "AIzaSyALsii1P1nKENhgszj1tz8pRqCXct3eck0",
                  authDomain: "ji-cloud-developer-sandbox.firebaseapp.com",
                  databaseURL:
                      "https://ji-cloud-developer-sandbox.firebaseio.com",
                  projectId: "ji-cloud-developer-sandbox",
                  storageBucket: "ji-cloud-developer-sandbox.appspot.com",
                  messagingSenderId: "735837525944",
                  appId: "1:735837525944:web:10e1fc18d5d10f04c3614d",
              };

    app = initializeApp(config);
    analytics = getAnalytics(app);
    db = getFirestore(app);

    console.log("firebase initialized! target:", target);
}

//This set is used to ignore dropped listeners
//Clear is called via Drop on the Rust side
let activeScreenshotListeners = new Set();
export function clearScreenshotListener(listenerId) {
    activeScreenshotListeners.delete(listenerId);
}

export function listenForScreenshotUpdates(
    jigId,
    moduleId,
    listenerId,
    onUpdated
) {
    activeScreenshotListeners.add(listenerId);

    const ref = doc(db, "screenshot", jigId, "modules", moduleId);
    onSnapshot(ref, (doc) => {
        const data = doc.data();
        if (data != null) {
            if (activeScreenshotListeners.has(listenerId)) {
                onUpdated();
            }
        }
    });
}
